import styled from 'styled-components';

import media from '../../../styles/media.style';
import { BLACK, PAGE_WIDTH } from '../../../styles/variables.style';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-direction: column;
  max-width: ${PAGE_WIDTH}px;
  height: 100%;
  min-height: 100vh;
  margin-bottom: 0 auto 10px auto;
  // background: linear-gradient(90deg, #a7b9c7 -40%, white, #a7b9c7 140%);
  overflow: hidden;
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 85px auto 0;
  overflow-y: scroll;
  ${media.tabletP`
    width: 728px;
    margin: 150px auto 0;
  `};
`;

export const TitleText = styled.div`
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  color: ${BLACK};
  margin-bottom: 20px;
  padding: 0 34px;
  ${media.tabletP`
    font-size: 28px;
    padding: 0;
    margin-bottom: 10px;
  `};
`;

export const DescriptionText = styled.div`
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: ${BLACK};
  margin-bottom: 22px;
  padding: 0 34px;
  ${media.tabletP`
    font-size: 16px;
    margin-bottom: 40px;
    padding: 0;
`};
`;

export const ItemWrap = styled.ul`
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0 21px 24px 21px;
  margin-bottom: 0;
  ${media.tabletP`
    width: 728px;
    padding: 0;
    padding-bottom: 60px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicHomeCareList/SublimitHomeCareList.style.js